import { render, staticRenderFns } from "./ti7.vue?vue&type=template&id=2386407e&scoped=true&"
import script from "./ti7.vue?vue&type=script&lang=js&"
export * from "./ti7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2386407e",
  null
  
)

export default component.exports